<template>
  <div id="app" :class="{ 'fix-ie': showLoader }">
    <div id="nprogress-container" class="nprogress-container" />
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AldAutomotive',

  computed: {
    showLoader() {
      return this.$store.getters['ui/data']('loader');
    }
  },

  mounted() {
    this.setTheme(this.$store.getters['ui/data']('theme'));
  },

  methods: {
    setTheme(theme) {
      this.$el.parentElement.className = `theme-${theme}`;
    }
  }
};
</script>
<style lang="scss" scoped>
#app {
  height: inherit;
  min-height: 100vh;
}
</style>
